import React from 'react';
import { useNavigate } from 'react-router-dom';
import SocialFooter from '../components/SocialFooter';
import { ArrowLeft, FileText, Warning, User, Gear } from '@phosphor-icons/react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_cardio-journey-app/artifacts/tyj7q2ct_logo%20365.png";

const Terms = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background relative overflow-hidden" data-testid="terms-screen">
      {/* Watermark */}
      <div
        className="absolute inset-0 opacity-[0.08] pointer-events-none"
        style={{
          backgroundImage: `url(${LOGO_URL})`,
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: '50%',
        }}
      />

      <header className="sticky top-0 z-40 bg-background/80 backdrop-blur-xl border-b border-border px-6 py-4">
        <div className="max-w-2xl mx-auto flex items-center gap-4">
          <button onClick={() => navigate(-1)} className="w-10 h-10 rounded-full bg-card flex items-center justify-center" data-testid="back-btn">
            <ArrowLeft weight="bold" className="w-5 h-5 text-foreground" />
          </button>
          <img src={LOGO_URL} alt="Track365" className="w-40 h-auto" />
          <h1 className="text-xl font-bold text-foreground" style={{ fontFamily: 'Outfit, sans-serif' }}>Terms of Service</h1>
        </div>
      </header>

      <main className="max-w-2xl mx-auto px-6 py-8 relative z-10">
        <div className="space-y-6">
          <div className="premium-card p-6">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-xl bg-[#D4AF37]/10 flex items-center justify-center flex-shrink-0 mt-1">
                <User weight="duotone" className="w-5 h-5 text-[#D4AF37]" />
              </div>
              <div>
                <h3 className="text-foreground font-semibold mb-2">Personal Use</h3>
                <p className="text-muted-foreground">
                  By using Track365 Cardio, you agree to use the app for personal, non-commercial purposes.
                </p>
              </div>
            </div>
          </div>

          <div className="premium-card p-6">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-xl bg-orange-500/10 flex items-center justify-center flex-shrink-0 mt-1">
                <Warning weight="duotone" className="w-5 h-5 text-orange-500" />
              </div>
              <div>
                <h3 className="text-foreground font-semibold mb-2">Medical Disclaimer</h3>
                <p className="text-muted-foreground">
                  Track365 is not a medical service and does not provide medical advice. Users are responsible for their own health and fitness decisions.
                </p>
              </div>
            </div>
          </div>

          <div className="premium-card p-6">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-xl bg-[#D4AF37]/10 flex items-center justify-center flex-shrink-0 mt-1">
                <Gear weight="duotone" className="w-5 h-5 text-[#D4AF37]" />
              </div>
              <div>
                <h3 className="text-foreground font-semibold mb-2">Service Updates</h3>
                <p className="text-muted-foreground">
                  We reserve the right to update features, pricing, and services at any time.
                </p>
              </div>
            </div>
          </div>

          <div className="premium-card p-6 border-red-500/20">
            <p className="text-muted-foreground">
              Violation of terms may result in account suspension.
            </p>
          </div>

          <p className="text-xs text-muted-foreground text-center">Last updated: March 2026</p>
        </div>

        <SocialFooter />
      </main>
    </div>
  );
};

export default Terms;
